<template>
  <div class="modal-card confirm-modal">
    <div class="modal-header">
      <p
        v-if="status === 'success'"
        class="modal-header-text"
      >
        {{ $t('exchange.complete') }}
      </p>
      <p
        v-if="status === 'fail'"
        class="modal-header-text"
      >
        {{ $t('exchange.failed') }}
      </p>
      <div
        class="modal-header-close-btn"
        @click="$parent.close()"
      >
        <img src="/static/svg/close-symbol.svg">
      </div>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <div class="modal-content-compare-rate">
          <div
            v-if="status === 'success'"
            class="text-info color-green"
          >
            <img src="/static/svg/icon-complete.svg">
            <span style="margin-left: 15px;">{{ $t('exchange.complete_detail') }}</span>
          </div>
          <div
            v-if="status === 'fail'"
            class="text-info color-red"
          >
            <img src="/static/svg/icon-fail.svg">
            <span style="margin-left: 15px;">{{ $t('exchange.failed_detail') }}</span>
          </div>
          <div class="address-info">
            <p>{{ $t('exchange.you_can_view_tx') }}</p>
            <a
              :href="`${etherScanUrl}/tx/${hash}`"
              target="_blank"
              class="address-info-tx"
            >
              {{ shortHash }}
              <img
                v-if="shortHash.length > 0"
                src="/static/svg/open-new-tab-blue.svg"
              >
            </a>
          </div>
          <div class="token-info">
            <div class="token-name-img">
              <img :src="`/static/token/normal/${source.code.toLowerCase()}.svg`">
            </div>
            <div class="token-name-lable">
              <div class="token-name-lable-code">
                {{ source.code }}
              </div>
              <div class="token-name-lable-fullname">
                {{ source.name }}
              </div>
              <div class="token-amount">
                {{ sourceAmount | numberWithComma }}
              </div>
            </div>
          </div>
          <div class="arrow">
            <img
              v-if="status === 'success'"
              :src="`/static/svg/arrow-right.svg`"
            >
            <img
              v-else
              :src="`/static/img/icon_fail.png`"
            >
          </div>
          <div class="token-info">
            <div class="token-name-img">
              <img :src="`/static/token/normal/${target.code.toLowerCase()}.svg`">
            </div>
            <div class="token-name-lable">
              <div class="token-name-lable-code">
                {{ target.code }}
              </div>
              <div class="token-name-lable-fullname">
                {{ target.name }}
              </div>
              <div class="token-amount">
                {{ targetAmount | numberWithComma }}
              </div>
            </div>
          </div>
        </div>
        <div class="token-rate">
          {{ $t('exchange.rate') }} 1 {{ source.code }} = {{ rateEstimate | numberWithComma }} {{ target.code }}
        </div>
        <div class="gas-info is-mobile-margin">
          <table class="tx-data">
            <tr
              v-for="(data, index) in txData"
              :key="index"
            >
              <td class="icon-fee">
                <img :src="`${data.iconImg}`">
              </td>
              <td style="width: 50%">
                {{ data.label }}
                <span>
                  <b-tooltip
                    :label="data.tooltipDetail"
                    type="is-light"
                    class="icon-info"
                  >
                    <img
                      src="/static/svg/exchange-info.svg"
                      class="network-fee-tootip-img"
                    >
                  </b-tooltip>
                </span>
              </td>
              <td style="width: 40%; text-align: right;">
                {{ data.value }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberWithComma } from '@/utils/helper'
export default {
  props: {
    status: {
      type: String,
      default: ''
    },
    source: {
      type: Object,
      default: () => {}
    },
    target: {
      type: Object,
      default: () => {}
    },
    sourceAmount: {
      type: Object,
      default: () => {}
    },
    targetAmount: {
      type: Object,
      default: () => {}
    },
    rateEstimate: {
      type: Object,
      default: () => {}
    },
    txFee: {
      type: Object,
      default: () => {}
    },
    platformFee: {
      type: [String, Number],
      default: 0
    },
    hash: {
      type: String,
      default: () => {}
    },
    etherScanUrl: {
      type: String,
      default: 'https://etherscan.io'
    }
  },
  computed: {
    txData () {
      let result = [
        {
          iconImg: '/static/svg/icon-transaction-fee-black.svg',
          label: this.$t('exchange.network_fee'),
          value: `${numberWithComma(this.txFee)} ETH`,
          tooltipDetail: this.$t('exchange.network_fee_detail')
        },
        {
          iconImg: '/static/svg/icon-platform-fee-black.svg',
          label: this.$t('exchange.platform_fee'),
          value: `${numberWithComma(this.platformFee, 3)} %`,
          tooltipDetail: this.$t('exchange.platform_fee_detail')
        }
      ]
      return result
    },
    shortHash () {
      if (this.hash) {
        const first = this.hash.substr(0, 12)
        const last = this.hash.substr(this.hash.length - 12, this.hash.length)
        return `${first}...${last}`
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .confirm-modal {
    float: left;
    width: 530px;
    background-color: #ffffff;
    border-radius: 5px;
  }
  .modal-header {
    float: left;
    width: 100%;
    height: 62px;
    background-color: #0559af;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-header-text {
    font-family: Roboto;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #ffffff;
  }
  .modal-header-close-btn {
    position: absolute;
    top: 15px;
    right: 19px;
  }
  .modal-header-close-btn {
    cursor: pointer;
  }
  .modal-body {
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  }
  .modal-content {
    width: 100%;
    float: left;
    padding: 40px 60px;
  }
  .modal-content-compare-rate {
    width: 100%;
    float: left;
  }
  .token-info{
    float: left;
    width: 35%;
    padding: 0px 15px;
  }
  .token-name-img {
    float: left;
    height: 40px;
    width: 40px;
    padding: 5px;
  }
  .token-name-lable {
    float: left;
    margin-left: 10px;
    width: calc(100% - 50px);
  }
  .token-name-lable-fullname {
    font-family: Roboto;
    font-size: 13px;
    font-weight: 300;
    color: #646464;
  }
  .token-name-lable-code {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
  .token-amount {
    float: left;
    font-family: DINAlternate !important;
    font-size: 17px;
    color: #363636;
    margin-top: 10px;
    max-width: 100%;
    width: 100%;
    text-align: right;
  }
  .token-rate {
    font-family: DINAlternate !important;
    font-size: 12px;
    color: #7d7d7d;
    margin-top: 10px;
    float: right;
  }
  .arrow {
    float: left;
    width: 30%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .gas-info {
    float: left;
    width: 100%;
    margin-top: 30px;
    padding: 0 5%;
  }
  .text-info{
    float: left;
    padding: 0px 15px;
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    text-align: center;
    font-family: Roboto;
    font-size: 15px;
    font-weight: bold;
  }
  .color-green {
    color: #41c536;
  }
  .color-red {
    color: #fc4a4a;
  }
  .address-info{
    float: left;
    padding: 0px 15px;
    width: 100%;
    text-align: center;
    margin: 30px 0;
  }
  .address-info-tx {
    color: #0564c4;
    margin-top: 5px;
  }
  .network-fee-tootip-img {
    margin-left: 4px;
  }
  .tx-data {
    width: 100%;
    tr:not(:last-child) {
      border-bottom: 1px solid #ddd;
    }
    tr:not(:first-child) {
      margin-top: 5px;
    }
    td {
      padding: 12px 0 12px 0;
    }
    .icon-fee {
      text-align: center;
    }
  }
  @media only screen and (max-width: 768px) {
    .confirm-modal {
      width: 100%;
      /* height: 530px; */
    }
    .modal-content {
      padding: 20px 0px;
      margin: 10px 0;
    }
    .token-info {
      text-align: center;
      width: 45%;
    }
    .arrow {
      width: 10%;
    }
    .token-name-img {
      width: 40px;
      height: 40px;
      margin: 0 auto;
      float: none;
    }
    .token-amount {
      text-align: center
    }
    .token-name-lable {
      margin-top: 5px;
      width: 100%;
      margin-left: 0px
    }
    .token-rate {
      float: left;
      width: 100%;
      text-align: center;
    }
    .is-mobile-margin {
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TradeResultModal.vue